import React, { useState } from 'react';

import { FileContext } from '@app/providers/FileProvider/FileContext';
import type { NFileProvider } from '@app/providers/FileProvider/FileProvider.types';

const Context = React.createContext('');

export const FileProvider: NFileProvider.Main = ({ children }) => {
  const [file, setFile] = useState('');
  const [extension, setExtension] = useState('');

  return (
    <FileContext.Provider
      value={{
        file,
        setFile,
        extension,
        setExtension,
      }}
    >
      <Context.Provider value={file}>{children}</Context.Provider>
    </FileContext.Provider>
  );
};
